import { connect } from 'react-redux'
import { clearOrderSearch, searchOrders } from '../../actions/order'
import { get } from 'lodash'

import TopNav from '../../components/orders/TopNav'

import { filterOrders } from '../../actions/order'

import { getIsKiosk, getTabsModeEnabled } from '../../selectors/menus'

import { getIsSyncing, getSomethingToSync } from '../../VNSyncManager/Selectors'

const mapStateToProps = (state) => {
  const currentSearch = get(state, 'order.ordersSearch')
  const hasUnsyncedOrders = getSomethingToSync(state)
  const isSyncInProgress = getIsSyncing(state)
  const isKiosk = getIsKiosk(state)
  const tabsModeEnabled = getTabsModeEnabled(state)

  return {
    currentSearch,
    hasUnsyncedOrders,
    isSyncInProgress,
    isKiosk,
    tabsModeEnabled,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClearSearch: () => dispatch(clearOrderSearch()),
    onSearch: (search) => dispatch(searchOrders(search)),
    filterOrders: (filter) => dispatch(filterOrders(filter)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNav)
